const STATUS_FOOD_SHOW = 0;
const STATUS_FOOD_HIDE = 1;

function food_details() {
  console.log('food_details');
}

export { food_details, STATUS_FOOD_SHOW, STATUS_FOOD_HIDE };
